import { AlternadorTema } from '@/components/status/alternador-tema';
import { LogoGrupoNicnet } from '@/components/status/logo-grupo-nicnet';

export const CabecalhoStatus = () => {
  return (
    <header className="mx-auto flex h-[70px] w-full max-w-[820px] items-center gap-3">
      <LogoGrupoNicnet className="h-6 w-auto flex-none text-foreground" />
      {/* Separador discreto: a marca já se identifica; "Status" diz o que é esta página. */}
      <span aria-hidden="true" className="h-4 w-px flex-none bg-border" />
      <span className="text-[15px] text-muted-foreground">Status</span>
      <div className="flex-1" />
      <a href="#historico" className="text-[13px] text-muted-foreground">
        Histórico
      </a>
      <AlternadorTema />
    </header>
  );
};
